import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ComponentHeader } from 'src/app/models/componentheader.model';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { BreadCrumb } from 'src/app/models/breadcrumb.model';
import { HeaderButton } from 'src/app/models/headerbtn.model';
import { Router } from '@angular/router';
import { UtilService } from 'src/app/services/util.service';
import { AssessmentmanagerService } from 'src/app/services/assessments/assessmentmanager.service';
import { data } from 'jquery';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';
import { UseraccessserviceService } from 'src/app/services/useraccessservice.service';
import { SchoolmanagementService } from 'src/app/services/schoolmanagement.service';
import * as introJs from 'intro.js/intro.js';
import { SchoolModuleEvent } from 'src/app/models/module/moduledetails';
import { EventDetail} from 'src/app/models/event/eventdetailsmodel';
declare var $: any;
import * as moment from 'moment';
import { FeatureGroups } from 'src/app/models/school/schooladminitem.model';
import { environment } from 'src/environments/environment';
import { CalendarEvent, CalendarEventType } from 'src/app/models/event/calendarevent';
//import timeGridPlugin from '@fullcalendar/timegrid';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit, AfterViewInit, OnDestroy {
  breadcrumb: BreadCrumb[];
  schoolId: number;
  headerbtn: HeaderButton[];
  assessmentsList: any;
  assessments: any[] = [];
  modulesURL: any;
  modulesPerPage: number = 4
  courseprogressdetails: any;
  courses: any;
  pendingcourse: boolean = true;
  completedcourse: boolean;
  pendingassignment: boolean = true
  submittedassignment: boolean;
  showdashboard:boolean=false;
  submittedCount = 0;
  pendingCount = 0;
  introJS = introJs();
  toursteps:any[]=[];
  schoolModuleEvent: SchoolModuleEvent[];
  showCalendar: boolean;
  eventDetail: EventDetail = new EventDetail();
  events: CalendarEvent[];
  filterdEvents: any= [];

  // inprogresscoursescount: any;
  // completedcoursescount: any;
  constructor(public headerinfo: ComponentheaderService, private router: Router, private util: UtilService,
    private assessmentManager: AssessmentmanagerService, private modulemanager: ModulemanagementService, private user: UseraccessserviceService,
    private schoolmanager: SchoolmanagementService) {
    console.log("home");
    console.log(this.headerinfo)
    this.toursteps=[

      {
        element: '#dashboardcourses',
        intro: "Registered Courses and Progress Appear Here",
        position: 'right'
      },
      {
        element: '#dashboardassessments',
        intro: 'Pending Assessments For The Week Appear Here',
        position: 'left'
      },
      {
        element: '#calendar',
        intro: 'Upcoming events, lectures, and assessment deadlines will appear here',
        position: 'right'
      }
  ];
  this.introJS.setOptions({
    steps: this.toursteps,
    showProgress: true
  });

  this.headerinfo.setHeaderDisplay('My Dashboard', [], [],this.toursteps);
}

  ngAfterViewInit(): void {
  }

  ngOnDestroy(): void {
    // fullCalendar attaches its own handlers to #calendar; without this the widget
    // and its listeners survive navigation away from the dashboard
    try {
      $('#calendar').fullCalendar('destroy');
    } catch (e) {
      console.log(e);
    }
  }

  async ngOnInit() {

    this.showdashboard=false;
    this.headerinfo.pageLoadingStarted(this);

    const schoolinfo: any = await this.schoolmanager.getSchoolFromSubdomain();
    await this.loadCalendar(schoolinfo.id);
    //var enrolled: any = await this.modulemanager.userhasenrollmentinschool().toPromise();
    //this.headerinfo.pageLoadingDone(this);

    /*if (!enrolled) {
      this.router.navigate(['/user/schoolhome'] );
      return;
    }*/
    this.showdashboard=true;
//this.headerinfo.pageLoadingStarted(this);

    {
      this.modulesURL = this.modulemanager.getMyEnrolledModulesURL();
      this.assessmentManager.getAssessmentsForDashboard().then(
        (response: any) => {
          this.assessmentsList = response;
          this.assessments = this.assessmentsList.filter((assessment) => {

            if (assessment.submitted) {
              this.submittedCount++;
            } else {
              this.pendingCount++;
            }
            return !assessment.submitted

          })


          console.log(this.pendingCount, this.submittedCount);
        }

      )
      this.courseprogressdetails = await this.modulemanager.getCourseprogressDetails().toPromise();

      // if(this.courseprogressdetails.length == 0){
      //   document.getElementById('calendar-flex').style.minHeight = '70vh';
      //   document.getElementById('calendar-flex').style.maxHeight = '70vh';
      // }
      //after data loaded
      //this.courses = this.courseprogressdetails.filter(function (course) { return (course.modulelessoncount > course.lessonlogcount); });
      //this.showpendingcourses();

      // const completedcourses= this.courseprogressdetails.filter(function (course) { return (course.modulelessoncount == course.lessonlogcount && course.modulelessoncount > 0); });
      // this.inprogresscoursescount= this.courses? this.courses.length:0;
      // this.completedcoursescount= completedcourses? completedcourses.length:0;

      this.showallcourses();

      this.headerinfo.pageLoadingDone(this);
    }

   // this.introJS.start();
  }

  async loadCalendar(id: number){
    if(!await this.util.hasFeature(FeatureGroups.EVENTS)){
      this.schoolModuleEvent = [];
    }
    else{
      this.schoolModuleEvent = await this.modulemanager.getAllUpcomingModuleInvites(id);
      for(let event of this.schoolModuleEvent){
        event.eventCssColor = 'var(--primary-darker)'
      }
    }
    this.showCalendar = this.schoolModuleEvent !== null && this.schoolModuleEvent.length > 0;
    this.showCalendar = true;
    if(!environment.production){
      this.showCalendar = true;
    }
    if (this.showCalendar){
      // Every one of these is mapped over below, so a failure must fall back to an
      // empty list rather than undefined. Previously a single failed request left
      // undefined here and the .map() call threw, taking out the whole calendar.
      const studentBatches: any = await this.modulemanager.getStudentCalendarBatches().toPromise().catch((e) => {
        console.log(e);
        return [];
      }) ?? []; // loads student batches for calender if any
      const schoolBatches: any = await this.modulemanager.getSchoolCalendarBatches_Admin().toPromise().catch((e) => {
        console.log(e); //loads all school batches, non-admins get an empty list back
        return [];
      }) ?? [];

      const studentAssessment: any = await this.assessmentManager.getAssessmentsForStudent().catch((e) => {
        console.log(e);
        return [];
      }) ?? [];
      const adminAssessment: any = await this.assessmentManager.getCalendarAssessmentsForAdmin().catch((e) => {
        console.log(e);
        return [];
      }) ?? [];

      this.events = this.schoolModuleEvent.map((item) => {
        let calEvt = new CalendarEvent;
        calEvt.title = 'Event: ' + item.subject;
        calEvt.start = item.inviteStartDate;
        calEvt.end = item.inviteEndDate;
        calEvt.description = item.body;
        calEvt.location = item.venue;
        calEvt.id = item.uniqueId;
        calEvt.startdate = item.inviteStartDate;
        calEvt.enddate = item.inviteEndDate;
        calEvt.color = item.eventCssColor;
        calEvt.lessonName = item.lessonTitle;
        return calEvt;

      });

      const mapBatchesToCalendarEvent = (item) => {
        let createBatchEvent = (secondEvent: boolean = false) => {
          let calEvt = new CalendarEvent;
          calEvt.title = item.isAdmin ? 'Batch: ' + item.moduleName + ' (Batch ' + item.name + ')' : 'Batch: ' + item.moduleName;
          calEvt.start = secondEvent ? item.endDate : item.startDate;
          calEvt.end = secondEvent ? item.endDate : item.startDate;
          calEvt.startdate = item.startDate;
          calEvt.enddate = item.endDate;
          calEvt.originalstart = item.startDate;
          calEvt.originalend = item.endDate;
          calEvt.description = 'For the Course ' + item.moduleName + ', Batch ' + item.name + ' starts on ' + this.util.formatDate(new Date(calEvt.startdate)) +
            ' till ' + this.util.formatDate(new Date(calEvt.enddate));
          calEvt.color = 'var(--primary-darker)';
          calEvt.calevent = CalendarEventType.Batch
          return calEvt;
        };
        return [createBatchEvent(), createBatchEvent(true)];
      };
      let batcharr = studentBatches.map(mapBatchesToCalendarEvent).reduce((acc, pair) => acc.concat(pair), []); // map student batch events
      let adminBatcharr = schoolBatches.map(mapBatchesToCalendarEvent).reduce((acc, pair) => acc.concat(pair), []); //map admin batch events

      let assessmentarr = studentAssessment.map((item) => { // map student assessment
        let createAssessmentEvent = (secondEvent: boolean = false) => {
          let s = this.util.convertCustomDateStringToCalendarISODateFormatString(item.starttime);
          let e = this.util.convertCustomDateStringToCalendarISODateFormatString(item.duedate)
          let calEvt = new CalendarEvent;
          calEvt.title = 'Assessment: ' + item.name;
          calEvt.startdate = this.util.convertCustomDateStringToCalendarISODateFormatString(item.starttime);
          calEvt.enddate = this.util.convertCustomDateStringToCalendarISODateFormatString(item.duedate);
          calEvt.start = secondEvent ? e : s;
          calEvt.end = secondEvent ? e : s;
          calEvt.originalstart = item.starttime;
          calEvt.originalend = item.duedate;
          calEvt.description =   item.name + ' Assessment for ' + item.coursetitle + ' Course' + ' starts ' + this.util.formatDate(new Date(calEvt.startdate)) + ' till ' + this.util.formatDate(new Date(calEvt.enddate));
          calEvt.assessmentlink = "/user/assessmentconsole?classid=" + item.classid +"&batchid=" + item.batchid;
          calEvt.color = 'var(--primary-darker)';
          calEvt.calevent = CalendarEventType.Assessment;
          return calEvt;
        };
        return [createAssessmentEvent(), createAssessmentEvent(true)];
      }).reduce((acc, pair) => acc.concat(pair), []);
      let adminAssessmentarr = adminAssessment.map((item) => { // map admin assessment events
        let createAssessmentEvent = (secondEvent: boolean = false) => {
          let calEvt = new CalendarEvent;
          calEvt.title = item.batchID === 0 ? 'Assessment: ' + item.name : 'Assessment: ' + item.name + ' (Batch ' + item.batchName + ')';
          calEvt.start = secondEvent ? item.batchStopTime : item.batchStartTime;
          calEvt.end = secondEvent ? item.batchStopTime : item.batchStartTime;
          calEvt.startdate = item.batchStartTime;
          calEvt.enddate = item.batchStopTime;
          let batchtext = item.batchName ? ' (Batch ' + item.batchName + ')' : " Course";
          calEvt.description = item.name + ' Assessment for ' + item.courseTitle + batchtext + ' starts ' + this.util.formatDate(new Date(calEvt.startdate)) + ' till ' + this.util.formatDate(new Date(calEvt.enddate));
          calEvt.assessmentlink = "/user/assessmentconsole?classid=" + item.classID +"&batchid=" + item.batchID;
          calEvt.color = 'var(--primary-darker)';
          calEvt.calevent = CalendarEventType.Assessment
          return calEvt;
        };
        return [createAssessmentEvent(), createAssessmentEvent(true)];
      }).reduce((acc, pair) => acc.concat(pair), []);

      this.events = [...this.events, ...batcharr, ...adminBatcharr, ...assessmentarr, ...adminAssessmentarr];

      $('#calendar').fullCalendar({
        header: {
          left: 'prev,next today',
          center: 'title',
          right: 'month,agendaWeek,agendaDay'
        },
        views: {
          agendaWeek: {
            columnFormat: 'ddd', // Display only the day of the week in column headers
            slotDuration: '01:00:00', // Set the duration of each time slot
            slotEventOverlap: false, // Prevent events from overlapping within a slot
            allDaySlot: false // Hide the all-day slot
          },
          agendaDay: {
            slotEventOverlap: false, // Prevent events from overlapping within a slot
          }
        },
        defaultView: 'month',
        editable: false,
        events: this.events,
        eventRender: function(event, element) {
          element.css('background-color', event.color);
        },
        eventClick: this.onEventClick,
        dayClick: this.onDateClicked
      });

      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      });
    }
    else{

    }
  }
  onDateClicked = (dateInfo: any) => {
    this.filterdEvents = this.events.filter((e)=> moment(e.start, 'YYYY-MM-DDTHH:mm:ss').isSame(moment(dateInfo.format(), 'YYYY-MM-DD'), 'day' ));

    // this.events.filter((e)=> (moment(e.end, 'YYYY-MM-DDTHH:mm:ss').isSameOrAfter(moment(dateInfo.format(), 'YYYY-MM-DD'), 'day' ) &&
    // (moment(e.start, 'YYYY-MM-DDTHH:mm:ss').isSameOrBefore(moment(dateInfo.format(), 'YYYY-MM-DD'), 'day' ) )));
  }
  onEventClick = (calEvent, jsEvent, view) => {
    const screenWidth = window.innerWidth;
    this.filterdEvents = this.events.filter((e)=> moment(e.start, 'YYYY-MM-DDTHH:mm:ss').isSame(moment(calEvent.start.format(), 'YYYY-MM-DD'), 'day' ));
    let isMobile = screenWidth < 768;
    if(isMobile){
      setTimeout(function() {
        const targetElement = $('#calenderupcomingeventsection');
        targetElement[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 0);
    }
  }
  popupEvent = (event: any, fromCalender = false) => {
    this.eventDetail = new EventDetail();
    this.eventDetail.eventName = event.title;
    this.eventDetail.start = event.start;
    this.eventDetail.end = event.end;
    this.eventDetail.originalstart = event.startdate;
    this.eventDetail.originalend = event.enddate;
    this.eventDetail.body = event.description;
    this.eventDetail.color = event.color;
    this.eventDetail.isLink = this.util.isLink(event.location);
    this.eventDetail.venue = this.eventDetail.isLink && !event.location.includes('http') ?  'https://' + event.location : event.location;
    this.eventDetail.assessmentlink = event.calevent === CalendarEventType.Assessment ? event.assessmentlink : '';
    this.eventDetail.lessonName = event.lessonName;
    $('#upcomingEventModal').modal('show');
  }
  showallcourses(){
    //debugger;
    this.courses = this.courseprogressdetails;
    this.completedcourse = false;
    this.pendingcourse = false;
  }

  // showcompletedcourses() {
  //   this.courses = this.courseprogressdetails.filter(function (course) { return (course.modulelessoncount == course.lessonlogcount && course.modulelessoncount > 0); });
  //   this.completedcourse = true;
  //   this.pendingcourse = false;
  // }

  // showpendingcourses() {
  //   this.courses = this.courseprogressdetails.filter(function (course) { return (course.modulelessoncount > course.lessonlogcount || course.modulelessoncount == 0); });
  //   this.pendingcourse = true;
  //   this.completedcourse = false;
  // }


  showsubmittedassessments() {
    if(this.assessmentsList){
      this.assessments = this.assessmentsList.filter(function (assessment) { return assessment.submitted })
      this.submittedassignment = true;
      this.pendingassignment = false;
    }
  }

  showpendingassessments() {
    if(this.assessmentsList){
      this.assessments = this.assessmentsList.filter(function (assessment) { return !assessment.submitted })
      this.pendingassignment = true
      this.submittedassignment = false
    }
  }
}
